import produce from 'immer';

const initialState = {
  resourceData: null,
  loading: false,
  error: null,
};

const FETCH_RESOURCE_DATA_REQUEST = 'FETCH_RESOURCE_DATA_REQUEST';
export const setFetchResourceDataRequest = {
  type: FETCH_RESOURCE_DATA_REQUEST,
};

const FETCH_RESOURCE_DATA_SUCCESS = 'FETCH_RESOURCE_DATA_SUCCESS';
export const setFetchResourceDataSuccess = (resourceData) => ({
  type: FETCH_RESOURCE_DATA_SUCCESS,
  payload: {
    ...resourceData,
  },
});

const FETCH_RESOURCE_DATA_FAILURE = 'FETCH_RESOURCE_DATA_FAILURE';
export const setFetchResourceDataFailure = (error) => ({
  type: FETCH_RESOURCE_DATA_FAILURE,
  payload: {
    ...error,
  },
});

const UPDATE_RESOURCE_ACTIVITY_REQUEST = 'UPDATE_RESOURCE_ACTIVITY_REQUEST';
export const setUpdateResourceActivityRequest = {
  type: UPDATE_RESOURCE_ACTIVITY_REQUEST,
};

const UPDATE_RESOURCE_ACTIVITY_SUCCESS = 'UPDATE_RESOURCE_ACTIVITY_SUCCESS';
export const setUpdateResourceActivitySuccess = (resourceData) => ({
  type: UPDATE_RESOURCE_ACTIVITY_SUCCESS,
  payload: {
    ...resourceData,
  },
});

const UPDATE_RESOURCE_ACTIVITY_FAILURE = 'UPDATE_RESOURCE_ACTIVITY_FAILURE';
export const setUpdateResourceActivityFailure = (error) => ({
  type: UPDATE_RESOURCE_ACTIVITY_FAILURE,
  payload: {
    ...error,
  },
});

const UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_REQUEST = 'UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_REQUEST';
export const setUpdateRecommendedResourceByScoreRequest = {
  type: UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_REQUEST,
};

const UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_SUCCESS = 'UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_SUCCESS';
export const setUpdateRecommendedResourceByScoreSuccess = (resourceData) => ({
  type: UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_SUCCESS,
  payload: {
    ...resourceData,
  },
});

const UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_FAILURE = 'UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_FAILURE';
export const setUpdateRecommendedResourceByScoreFaluire = (error) => ({
  type: UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_FAILURE,
  payload: {
    ...error,
  },
});

export const selectResourceData = ({ resourceDataReducer }) =>
  resourceDataReducer?.resourceData || {};

export default function resourceDataReducer(state = initialState, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case FETCH_RESOURCE_DATA_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;
      case UPDATE_RESOURCE_ACTIVITY_REQUEST:
        draft.error = null;
        break;
      case FETCH_RESOURCE_DATA_SUCCESS:
        draft.resourceData = action.payload;
        draft.loading = false;
        break;
      case UPDATE_RESOURCE_ACTIVITY_SUCCESS:
        draft.resourceData.resources = draft.resourceData.resources?.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              isLiked: action.payload.isLiked,
              isCompleted: action.payload.isCompleted,
              isRecommended: action.payload.isRecommended,
            };
          }
          return item;
        });
        break;
      case FETCH_RESOURCE_DATA_FAILURE:
        draft.error = action.payload;
        draft.loading = false;
        break;
      case UPDATE_RESOURCE_ACTIVITY_FAILURE:
        draft.error = action.payload;
        break;
      case UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_REQUEST:
        draft.error = null;
        break;
      case UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_SUCCESS:
        const updatedResourceIds = action.payload.resources.map((obj) => obj.id);
        draft.resourceData.resources = draft.resourceData.resources?.map((item) => {
          return {
            ...item,
            isRecommended: updatedResourceIds.includes(item.id),
          };
        });
        break;
      case UPDATE_RECOMMENDED_RESOURCE_BY_SCORE_FAILURE:
        draft.error = action.payload;
        break;
      default:
        break;
    }
  });
}
